import React from "react";

export default function AboutTab() {
  return (
    <section className="card lg section">
      <div className="section-head">
        <h2 className="h2">What Is This Path?</h2>
      </div>

      <p className="sm">
        This space is inspired by Jon Kabat-Zinn’s work and the wider
        mindfulness tradition. It isn’t about fixing yourself or becoming a
        better version of who you already are. It is about{" "}
        <strong>waking up to your life</strong>, as it is, and discovering your
        capacity to respond with wisdom and kindness.
      </p>

      <p className="sm">
        The word <em>response-ability</em> here points to the space between
        stimulus and response — the moment where awareness can open, even
        slightly, and a different choice becomes possible.
      </p>

      <p className="xs muted">
        “As long as you are breathing, there is more right with you than wrong
        with you.” — Jon Kabat-Zinn
      </p>
    </section>
  );
}
